import { createRoute, redirect } from "@tanstack/react-router";
import LoginPageLayout from "@/layouts/pages/loginPageLayout/LoginPageLayout";
import LoginPage from "@/views/loginPage/LoginPage";
import { getToken } from "@/utils/auth/helpers";
import {
  getNaniClubOidcAuthUrl,
  isNaniClubOidcEnabled,
} from "@/utils/auth/naniClubOidc";
import { Route } from "./__root";

export const loginRoute = createRoute({
  getParentRoute: () => Route,
  path: "/login",
  validateSearch: (search: Record<string, unknown>): { reason?: string } => ({
    reason: (search.reason as string) || undefined,
  }),
  beforeLoad: () => {
    // 已登入的話直接導回
    if (getToken()) {
      throw redirect({ to: "/", replace: true });
    }

    // nani 網域轉到 nani club 登入
    if (isNaniClubOidcEnabled()) {
      throw redirect({ href: getNaniClubOidcAuthUrl() });
    }
  },
  component: () => (
    <LoginPageLayout>
      <LoginPage />
    </LoginPageLayout>
  ),
});
